// extracted by mini-css-extract-plugin
export default {"colorTangelo":"#fc4c02","carousel":"carousel_carousel__RZJ2y","no-hover":"carousel_no-hover__CjcsK"};